module.exports = "/_next/static/images/tv-left-uv-441eeb0dfe3c12c7db64ebf89ceca58d.png";